import { type DefaultOptions, QueryClient } from '@tanstack/react-query'

const queryConfig: DefaultOptions = {
    queries: {
        throwOnError: false,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 30000,
    },
    mutations: {
        throwOnError: false,
    },
}

export const queryClient = new QueryClient({ defaultOptions: queryConfig })
